module.exports = __webpack_public_path__ + "img/right-chevron-black.98164534.svg";